import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function ProtectedRoute({ children, requiredRole, requiredSection }) {
  const { user, loading, isAuthenticated, isSuperAdmin, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-10 h-10 border-4 border-[#0E6D2B] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // Check role requirements
  if (requiredRole === 'superadmin' && !isSuperAdmin) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (requiredRole === 'admin' && !isAdmin) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  // Check section access
  if (requiredSection) {
    // Super Admin has access to all sections
    if (!isSuperAdmin) {
      const hasAccess = user?.assigned_sections?.includes(requiredSection);
      if (!hasAccess) {
        return <Navigate to="/admin/dashboard" replace />;
      }
    }
  }

  return children;
}
